/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const LoginErrors = {
    EMAIL_NOT_VERIFIED: 'verify_mail',
    ID_TOKEN_VERIFICATION_FAILED: 'verify_fail',
    AUTH_ERROR: 'auth_error'
};
